<template>
    <div class="row">
            <!-- Menú lateral siempre visible pero con tamaño adaptativo -->
            <b-col cols="12" md="3" lg="2" class="menu-container">
                <menu-component @updateFilter="receivedFilter = $event"/>
            </b-col>

            <!-- Contenido de la tabla -->
            <b-col cols="12" md="9" lg="10">
                <TableComponent :items="errors" :fields="fields"/>
            </b-col>
    </div>
</template>

<script>
import ErroresDataService from "../../../services/ErroresDataService";
import Crypto from "../../../services/Crypto";
import TableComponent from "./TableComponent.vue";
import MenuComponent from "./MenuComponent.vue";
import { verificarAcceso } from '../../../utils/Session';
export default {
    components:{
        TableComponent,
        MenuComponent,
    },
    data() {
        return {
            fields:[
                { key: 'categoria',         label: 'Categoría',         sortable: true, },
                { key: 'fechaCreacion',     label: 'Fecha',             sortable: true, },
                { key: 'proyecto',          label: 'Proyecto',          sortable: true, },
                { key: 'mensaje',           label: 'Mensaje', },
                { key: 'stackTrace',        label: 'Stack Trace', },
                { key: 'infoDispositivo',   label: 'Dispositivo', },
                { key: 'usuario',           label: 'Usuario', },
            ],
            receivedFilter: null,
            key: sessionStorage.getItem('key'),
            errors: [],
        };
    },
    beforeCreate() {
        verificarAcceso();
    },
    mounted() {
        this.getAllErrors();
    },
    watch: {
        receivedFilter: {
                handler(newFilter) {
                    const isEmptyFilter = this.checkIsEmptyFilter(newFilter);
                    if(isEmptyFilter){
                        this.getAllErrors();
                    }else{
                        this.getErrorsByFilter(newFilter);
                    }
                },
                deep: true,
            },
        },
    methods: {
        /**
         * Metodo que consume el servicio para obtener los registros de TODOS los errores
         */
        async getAllErrors() {
            try {
                const response = await ErroresDataService.obtenerTodos();
                const decoded = await Crypto.desencriptar(response.data, this.key);
                this.errors = decoded.map(this.getDisplayErrores);
            } catch (e) {
                console.error(e);
            }
        },
        checkIsEmptyFilter(filter){
            let isEmpty = false;
            if(!filter.projects.length && !filter.date.start && !filter.date.end && !filter.levels.length){
                isEmpty = !isEmpty;
            }
            return isEmpty;
        },
        async getErrorsByFilter(filter){
            try{
                const response = await ErroresDataService.obtenerPorFiltro(filter, this.key);
                const decoded = await Crypto.desencriptar(response.data, this.key);
                console.log(decoded.length)
                this.errors = decoded.map(this.getDisplayErrores);
            }catch(e){
                console.error(e);
            }
        },

        getDisplayErrores(error) {
            let options = {
                year: "numeric",
                month: "numeric",
                day: "numeric",
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
            };
            return {
                categoria: error.categoria,
                fechaCreacion: new Date(error.fechaCreacion).toLocaleDateString('es-ES', options),
                proyecto: error.proyecto,
                mensaje: error.mensaje,
                stackTrace: error.stackTrace ? error.stackTrace: 'Sin datos',
                infoDispositivo: error.infoDispositivo,
                usuario: error.usuario ? error.usuario.matricula : 'No disponible',
            };
        },
    },
};
</script>

<style>
/* Tamaño del menú adaptado a diferentes resoluciones */
.menu-container {
    transition: all 0.3s ease-in-out;
}
</style>
